import { render, staticRenderFns } from "./WidgetsDashboardInspectors.vue?vue&type=template&id=6a1091f4"
import script from "./WidgetsDashboardInspectors.vue?vue&type=script&lang=js"
export * from "./WidgetsDashboardInspectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports